export const setSession = (action, data = null) => {
  if (action) {
    localStorage.setItem("action", action);
  } else {
    localStorage.removeItem("action");
  }
  if (data) {
    localStorage.setItem("data", data);
  }
  else{
    localStorage.removeItem("data");
  }
};

export const resetSession = () => {
  localStorage.removeItem("action");
  localStorage.removeItem("data");
};
